export default __webpack_public_path__ + "static/media/more-icon.225683bd.svg";